import React from "react";
import IMAGE_URL from "Utilities/IMAGE_URL";
import Container from "Components/Container/Container";
const AboutUsContent = ({ data }) => {
  return (
    <section className="mt-secondary lg:mt-primary ">
      <Container>
        <div className="flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1">
            <img src={`${IMAGE_URL}/${data?.aboutImage}`} alt={data?.title} />
          </div>
          <div className="flex-1">
            <h2 className="text-4xl  mb-3 font-title ">{data?.aboutTitle}</h2>

            <div
              className="font-text text-[#555]  "
              dangerouslySetInnerHTML={{ __html: data?.aboutDescription }}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AboutUsContent;
